import React from 'react';
import { Modal } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import './DeleteConfirmationModal.css';

export const DeleteConfirmationModal = (props) => {
    const { t } = useTranslation();

    return (
        <Modal
            isOpen={props.open}
            centered
            contentClassName="dcm-content"
            modalClassName="dcm-modal-wrapper"
        >
            {/* Header */}
            <div className="dcm-header">
                <span className="dcm-title">
                    {t("Supprimer l'utilisateur")}
                    {props.userName ? ` "${props.userName}"` : ''}
                </span>
                <button
                    type="button"
                    className="dcm-btn-close"
                    onClick={props.handleClose}
                    aria-label="Close"
                >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                            d="M12 4L4 12M4 4l8 8"
                            stroke="#616161"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                    </svg>
                </button>
            </div>

            {/* Body */}
            <div className="dcm-body">
                <p className="dcm-message">
                    {t("Vous êtes sur le point de supprimer définitivement l'utilisateur")}{' '}
                    {props.userRole ? <>{props.userRole} </> : ''}
                    {props.userName ? <strong>"{props.userName}"</strong> : ''}.{' '}
                    {t('Toutes les données associées seront supprimées de manière irréversible.')}
                </p>
            </div>

            {/* Footer */}
            <div className="dcm-footer">
                <button className="dcm-btn-cancel" onClick={props.handleClose}>
                    {t('Annuler')}
                </button>
                <button className="dcm-btn-delete" onClick={props.executeAction}>
                    {t("Supprimer l'utilisateur")}
                </button>
            </div>
        </Modal>
    );
};

export default DeleteConfirmationModal;